// extracted by mini-css-extract-plugin
export default {"plain-text":"mK4WtWZ98g","plainText":"mK4WtWZ98g"};